import { STREAM_STATUS } from "constants/phase";

export const streamStatus = {
  [STREAM_STATUS.COMPLETED]: "Completed",
  [STREAM_STATUS.PROCESSING]: "Processing",
  [STREAM_STATUS.PENDING]: "Pending",
  [STREAM_STATUS.FAILED]: "Failed",
  [STREAM_STATUS.CANCELLED]: "Cancelled",
  [STREAM_STATUS.DELAYED]: "Delayed",
};

export const logsType = {
  editStream: "edit stream",
};

export const streamStatusFilterOption = [
  { key: "all", value: "All" },
  { key: "1", value: "Completed" },
  { key: "2", value: "Live" },
  { key: "3", value: "Pending" },
  { key: "4", value: "Failed" },
  { key: "5", value: "Cancelled" },
];

export const noDownloadStreams = [
  "cJAo7E3Ly",
  "EgUlHq35G",
  "oZ9sRBeim",
  "qbRSXoKi-",
  "hzb.lmR6x",
  "qDnhWKqYs",
  "LEcqJo8Wu",
  "SGLxQ3UOw",
  "Enlp1AT7w",
  "ebIEFG.Yp",
];
